import React from 'react';
import { ArrowRight } from '@lt/components/icons-react';
import styled from 'styled-components';

export const ArrowComponent = ({ isMobile }) => (
  <StyledArrowComponent>
    <div className="swiper-button-prev" id="always-active-button">
      <StyledArrowLeft isMobile={isMobile} />
    </div>
    <div className="swiper-button-next" id="always-active-button">
      <StyledArrowRight isMobile={isMobile} />
    </div>
  </StyledArrowComponent>
);

const StyledArrowComponent = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    &::after {
      content: '';
    }
  }
`;

const StyledArrowRight = styled(ArrowRight)<{ isMobile: boolean }>`
  width: ${({ isMobile }) => (isMobile ? 10 : 27)}px;
`;

const StyledArrowLeft = styled(StyledArrowRight)`
  transform: rotate(180deg);
`;
